/**!
 * Created by Leonardo Cheslacki on 27/06/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import HelpersController from './HelpersController';

import WithType from './WithType';

import {HelpersPin} from './';

let _this = {};

/**
 *
 */
class HelpersIcon extends HelpersController {

    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);
        this.props = props;
        this.main = main;

        const {current_name} = this.props;

        this.$helpersPin = HelpersPin(this)({current_name: current_name});

        _this = this;
    };

    /**
     *
     * @param occ_align
     * @param color
     * @param occ_icon
     */
    setColor = (occ_align, color, occ_icon = '') => {
        if (this.isTintColor(color)) {
            this.$helpersPin.setColor(this.verifyField(occ_align, 'occ_effect.occ_round'), color);
            this.$helpersPin.setColor(this.verifyField(occ_align, 'occ_effect.occ_animate.occ_round_first'), color);
            this.$helpersPin.setColor(this.verifyField(occ_align, 'occ_effect.occ_animate.occ_round_second'), color);
            !this.isEmpty(occ_icon) && this.$helpersPin.setColor(this.verifyField(occ_align, occ_icon), color);
        }
    };

    /**
     *
     * @param _this
     * @param color
     * @param occ
     */
    setIcon = (_this, color = null, occ = false) => {
        let
            occ_icon_more = this.verifyField(_this, 'occ_icon_more'),
            occ_icon_less = this.verifyField(_this, 'occ_icon_less'),
            occ_icon_prev = this.verifyField(_this, 'occ_icon_prev'),
            occ_icon_next = this.verifyField(_this, 'occ_icon_next'),
            occ_icon_close = this.verifyField(_this, 'occ_icon_close'),
            occ_icon_point = this.verifyField(_this, 'occ_icon_point'),
            occ_icon_autumn = this.verifyField(_this, 'occ_icon_autumn'),
            occ_icon_winter = this.verifyField(_this, 'occ_icon_winter'),
            occ_icon_spring = this.verifyField(_this, 'occ_icon_spring'),
            occ_icon_summer = this.verifyField(_this, 'occ_icon_summer'),
            occ_icon_none = this.verifyField(_this, 'occ_icon_none');

        if(occ){
            let
                pad_number = this.padWithLeadingZeros(occ, 2),
                occ_icon_frame = this.verifyField(_this, `occ_icon_frame${pad_number}`),
                occ_icon_page = this.verifyField(_this, `occ_icon_page${pad_number}`),
                occ_icon_pav = this.verifyField(_this, `occ_icon_pav${pad_number}`);

            if (occ_icon_frame) {
                !this.isEmpty(color) && this.setColor(occ_icon_frame, color, 'occ_more');
            }

            if (occ_icon_page) {
                !this.isEmpty(color) && this.setColor(occ_icon_page, color, 'occ_more');
            }

            if (occ_icon_pav) {
                !this.isEmpty(color) && this.setColor(occ_icon_pav, color, 'occ_more');
            }
        }

        if (occ_icon_more) {
            occ_icon_more.occ_more.visible = true;
            occ_icon_more.occ_less.visible = false;
            occ_icon_more.occ_prev.visible = false;
            occ_icon_more.occ_next.visible = false;
            occ_icon_more.occ_close.visible = false;
            occ_icon_more.occ_point.visible = false;
            occ_icon_more.occ_autumn.visible = false;
            occ_icon_more.occ_winter.visible = false;
            occ_icon_more.occ_spring.visible = false;
            occ_icon_more.occ_summer.visible = false;

            !this.isEmpty(color) && this.setColor(occ_icon_more, color, 'occ_more');
        }

        if (occ_icon_less) {
            occ_icon_less.occ_more.visible = false;
            occ_icon_less.occ_less.visible = true;

            !this.isEmpty(color) && this.setColor(occ_icon_less, color, 'occ_less');
        }

        if (occ_icon_prev) {
            occ_icon_prev.occ_more.visible = false;
            occ_icon_prev.occ_prev.visible = true;

            !this.isEmpty(color) && this.setColor(occ_icon_prev, color, 'occ_prev');
        }

        if (occ_icon_next) {
            occ_icon_next.occ_more.visible = false;
            occ_icon_next.occ_next.visible = true;

            !this.isEmpty(color) && this.setColor(occ_icon_next, color, 'occ_next');
        }

        if (occ_icon_close) {
            occ_icon_close.occ_more.visible = false;
            occ_icon_close.occ_close.visible = true;

            !this.isEmpty(color) && this.setColor(occ_icon_close, color, 'occ_close');
        }

        if (occ_icon_point) {
            occ_icon_point.occ_more.visible = false;
            occ_icon_point.occ_point.visible = true;

            !this.isEmpty(color) && this.setColor(occ_icon_point, color, 'occ_point');
        }

        if (occ_icon_autumn) {
            occ_icon_autumn.occ_more.visible = false;
            occ_icon_autumn.occ_autumn.visible = true;

            !this.isEmpty(color) && this.setColor(occ_icon_autumn, color, 'occ_autumn');
        }

        if (occ_icon_winter) {
            occ_icon_winter.occ_more.visible = false;
            occ_icon_winter.occ_winter.visible = true;

            !this.isEmpty(color) && this.setColor(occ_icon_winter, color, 'occ_winter');
        }

        if (occ_icon_spring) {
            occ_icon_spring.occ_more.visible = false;
            occ_icon_spring.occ_spring.visible = true;

            !this.isEmpty(color) && this.setColor(occ_icon_spring, color, 'occ_spring');
        }

        if (occ_icon_summer) {
            occ_icon_summer.occ_more.visible = false;
            occ_icon_summer.occ_summer.visible = true;

            !this.isEmpty(color) && this.setColor(occ_icon_summer, color, 'occ_summer');
        }

        if (occ_icon_none) {
            occ_icon_none.occ_more.visible = false;
            occ_icon_none.occ_less.visible = false;
            occ_icon_none.occ_prev.visible = false;
            occ_icon_none.occ_next.visible = false;
            occ_icon_none.occ_close.visible = false;
            occ_icon_none.occ_point.visible = false;
            occ_icon_none.occ_autumn.visible = false;
            occ_icon_none.occ_winter.visible = false;
            occ_icon_none.occ_spring.visible = false;
            occ_icon_none.occ_summer.visible = false;

            !this.isEmpty(color) && this.setColor(occ_icon_summer, color);
        }
    };

    /**
     *
     * @param _this
     * @returns {(function(*, boolean=): void)|*}
     */
    disabledAnimate = (_this) => (occ, name = 'page') => {
        let
            pad_number = this.padWithLeadingZeros(occ, 2),
            occ_icon_more = this.verifyField(_this, 'occ_icon_more'),
            occ_icon_less = this.verifyField(_this, 'occ_icon_less'),
            occ_icon_prev = this.verifyField(_this, 'occ_icon_prev'),
            occ_icon_next = this.verifyField(_this, 'occ_icon_next'),
            occ_icon_close = this.verifyField(_this, 'occ_icon_close'),
            occ_icon_point = this.verifyField(_this, 'occ_icon_point'),
            occ_icon_autumn = this.verifyField(_this, 'occ_icon_autumn'),
            occ_icon_winter = this.verifyField(_this, 'occ_icon_winter'),
            occ_icon_spring = this.verifyField(_this, 'occ_icon_spring'),
            occ_icon_summer = this.verifyField(_this, 'occ_icon_summer'),
            occ_icon_none = this.verifyField(_this, 'occ_icon_none'),
            occ_icon = this.verifyField(_this, `occ_icon_${name}${pad_number}`);

        if (occ_icon_more) {
            occ_icon_more.occ_effect.occ_animate.visible = !(occ === 'more');
        }

        if (occ_icon_less) {
            occ_icon_less.occ_effect.occ_animate.visible = !(occ === 'less');
        }

        if (occ_icon_prev) {
            occ_icon_prev.occ_effect.occ_animate.visible = !(occ === 'prev');
        }

        if (occ_icon_next) {
            occ_icon_next.occ_effect.occ_animate.visible = !(occ === 'next');
        }

        if (occ_icon_close) {
            occ_icon_close.occ_effect.occ_animate.visible = !(occ === 'close');
        }

        if (occ_icon_point) {
            occ_icon_point.occ_effect.occ_animate.visible = !(occ === 'point');
        }

        if (occ_icon_autumn) {
            occ_icon_autumn.occ_effect.occ_animate.visible = !(occ === 'autumn');
        }

        if (occ_icon_winter) {
            occ_icon_winter.occ_effect.occ_animate.visible = !(occ === 'winter');
        }

        if (occ_icon_spring) {
            occ_icon_spring.occ_effect.occ_animate.visible = !(occ === 'spring');
        }

        if (occ_icon_summer) {
            occ_icon_summer.occ_effect.occ_animate.visible = !(occ === 'summer');
        }

        if (occ_icon_none) {
            occ_icon_none.occ_effect.occ_animate.visible = !(occ === 'none');
        }

        if (occ_icon) {
            occ_icon.occ_effect.occ_animate.visible = false;
        }
    };
}

/**
 *
 * @type {{}}
 */
HelpersIcon.propTypes = {};

/**
 *
 * @type {{}}
 */
HelpersIcon.defaultProps = {};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(HelpersIcon, {className: 'HelpersIcon'});
